// ─── Filters (ADR-119) ───────────────────────────────────────────────────────
export const REPORT_CUSTOMER_TYPES = ['guest', 'first', 'returning'];
export const REPORT_PAYMENT_METHODS = ['COD', 'CARD', 'MANUAL', 'WALLET'];
export const REPORT_FILTER_LISTS = [
    'status',
    'payment',
    'channel',
    'region',
    'city',
    'category',
    'brand',
    'product',
    'customer',
    'stage',
    'group',
    'coupon',
    'shippingMethod',
    'carrier',
    'assignee',
];
/** Values searched from what orders hold (ADR-119): `GET /admin/reports/filter-values`. */
export const REPORT_FILTER_VALUE_FIELDS = ['region', 'city', 'coupon', 'carrier'];
export function hasFilters(filters) {
    return (REPORT_FILTER_LISTS.some((key) => (filters[key]?.length ?? 0) > 0) ||
        filters.fulfilment !== undefined ||
        filters.minTotal !== undefined ||
        filters.maxTotal !== undefined);
}
/** Query string form: lists comma-joined, the order the server reads them. */
export function filtersToQuery(filters) {
    const query = {};
    for (const key of REPORT_FILTER_LISTS) {
        const values = filters[key];
        if (values && values.length > 0)
            query[key] = values.join(',');
    }
    if (filters.fulfilment)
        query.fulfilment = filters.fulfilment;
    if (filters.minTotal !== undefined)
        query.minTotal = String(filters.minTotal);
    if (filters.maxTotal !== undefined)
        query.maxTotal = String(filters.maxTotal);
    return query;
}
// ─── Saved views (ADR-119, ADR-122) ──────────────────────────────────────────
export const REPORT_RANGE_PRESETS = ['last7', 'last30', 'last90', 'thisMonth', 'lastMonth', 'thisYear', 'fixed'];
// ─── Custom reports (ADR-122) ────────────────────────────────────────────────
export const CUSTOM_DATASETS = ['orders', 'lines', 'customers'];
export const INSIGHT_KINDS = [
    'restock',
    'slow_stock',
    'at_risk_customers',
    'coupon_loss',
    'city_cod_cancellations',
    'viewed_not_bought',
    'conversion_drop',
    'carts_without_reminders',
    'behind_target',
    'returned_often',
    'missing_costs',
];
const dim = (key, type = 'text', groupable = true) => ({ key, kind: 'dimension', type, groupable });
const measure = (key, type = 'money') => ({ key, kind: 'measure', type });
/**
 * What each dataset can show (ADR-122). The server holds the SQL for every
 * key here; a key it does not know is refused.
 */
export const CUSTOM_COLUMNS = {
    orders: [
        dim('day', 'date'),
        dim('week', 'date'),
        dim('month', 'text'),
        dim('number', 'text', false),
        dim('status'),
        dim('payment'),
        dim('channel'),
        dim('region'),
        dim('city'),
        dim('coupon'),
        dim('shippingMethod'),
        dim('assignee'),
        dim('customerType'),
        dim('stage'),
        dim('email', 'text', false),
        measure('orders', 'number'),
        measure('units', 'number'),
        measure('revenue'),
        measure('averageOrder'),
        measure('discounts'),
        measure('shipping'),
        measure('vat'),
        measure('cost'),
        measure('profit'),
        measure('margin', 'percent'),
        measure('buyers', 'number'),
    ],
    lines: [
        dim('day', 'date'),
        dim('week', 'date'),
        dim('month', 'text'),
        dim('number', 'text', false),
        dim('product'),
        dim('sku'),
        dim('category'),
        dim('brand'),
        dim('status'),
        dim('payment'),
        dim('channel'),
        dim('region'),
        dim('city'),
        dim('coupon'),
        measure('units', 'number'),
        measure('orders', 'number'),
        measure('revenue'),
        measure('netRevenue'),
        measure('cost'),
        measure('profit'),
        measure('margin', 'percent'),
    ],
    customers: [
        dim('email', 'text', false),
        dim('name', 'text', false),
        dim('city'),
        dim('region'),
        dim('stage'),
        dim('customerType'),
        dim('firstOrder', 'date', false),
        dim('lastOrder', 'date', false),
        measure('buyers', 'number'),
        measure('orders', 'number'),
        measure('revenue'),
        measure('averageOrder'),
    ],
};
//# sourceMappingURL=reports.js.map